import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { AsideSticky, Main, Page, Content } from '../../components/Page';
import { FixedHeader } from '../FixedHeader';
import { Responsive } from '@cian/ui-kit';
import { AsideSection } from '../../components/AsideSection/AsideSection';
import { BreadCrumbs } from '../BreadCrumbs';
import { PriceBlock } from '../PriceBlock';
import { SeoLinksContainer } from '../SeoLinks/SeoLinksContainer';
import { PageTitleContainer } from '../PageTitle/PageTitle';
import { BuilderInfo } from '../BuilderInfo';
import { SpecificationsContainer } from '../Specifications';
import { BuildersContainer } from '../BuildersMobile';

import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { CallToActionContainer } from '../MobileCall';
import { MainSection } from '../../components/MainSection';
import { OffersStatsContainer } from '../OffersStats';
import { LayoutsWidget } from '../LayoutsWidget';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <Page>
              <FixedHeader />
              <BreadCrumbs />
              <Content>
                <Main>
                  <Responsive desktop>
                    <SeoLinksContainer />
                  </Responsive>
                  <MainSection>
                    <PageTitleContainer />
                    <LayoutsWidget />
                    <SpecificationsContainer />
                    <Responsive desktop>
                      <OffersStatsContainer />
                    </Responsive>
                  </MainSection>
                  <Responsive tablet phone>
                    <BuildersContainer />
                  </Responsive>
                  <Responsive tablet phone>
                    <SeoLinksContainer />
                  </Responsive>
                  <Responsive tablet phone>
                    <OffersStatsContainer />
                  </Responsive>
                </Main>
                <AsideSticky>
                  <AsideSection>
                    <PriceBlock />
                  </AsideSection>
                  <AsideSection>
                    <BuilderInfo />
                  </AsideSection>
                </AsideSticky>
              </Content>
            </Page>
            <Responsive tablet phone>
              <StickyBottomLayout>
                <CallToActionContainer />
              </StickyBottomLayout>
            </Responsive>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
